export const workoutsCmsHelperText =
  "Settings for self-guided Workout flows featured in Coa's native mobile app.";
